import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../../data";
import { maskLine, EASE } from "../../lib/anim";

const LINES = ["Creating the future", "from a higher perspective."];

export const FinalCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);

  return (
    <section id="contact" ref={ref} className="relative h-[100svh] w-full overflow-hidden" data-testid="final-cta-section">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src={IMAGES.cta} alt="Cockpit al tramonto in quota — MGB Aviation" title="MGB Aviation" draggable="false" className="h-full w-full object-cover object-[center_32%] grayscale-[0.65] contrast-105" />
      </motion.div>
      <div className="absolute inset-0 bg-[#060607]/45" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#060607] via-[#060607]/30 to-[#060607]/60" />

      <div className="relative z-10 h-full max-w-[1500px] mx-auto px-6 lg:px-12 flex flex-col items-center justify-center text-center">
        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          variants={{ show: { transition: { staggerChildren: 0.12 } } }}
          className="font-display font-semibold text-white leading-[1.05] tracking-tight text-[9vw] sm:text-[6vw] lg:text-[4.6vw] max-w-[18ch]"
        >
          {LINES.map((line, i) => (
            <span key={i} className="line-mask">
              <motion.span variants={maskLine} className="block">
                {line}
              </motion.span>
            </span>
          ))}
        </motion.h2>

        <motion.a
          href="mailto:info@mgbaviation.com"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: EASE, delay: 0.5 }}
          data-testid="final-cta-button"
          className="group relative mt-14 inline-flex items-center gap-4 bg-white pl-8 pr-7 py-5 overflow-hidden"
        >
          <span className="absolute inset-0 bg-[#060607] translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" />
          <span className="relative font-mono-x text-[13px] tracking-[0.22em] uppercase text-[#060607] group-hover:text-white transition-colors duration-500">
            Collaboriamo
          </span>
          <ArrowUpRight size={17} className="relative text-[#060607] group-hover:text-white transition-colors duration-500" />
        </motion.a>
      </div>
    </section>
  );
};
